<template>
  <div class="row">
    <div class="col">
      <h2 class="titre">Consultation Billet</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Nom de la loterie :</label>
        </div>
        <div class="col txt">
          <p v-if="!billet.nom"> ... </p>
          <p v-else> {{ billet.nom }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Type de loterie :</label>
        </div>
        <div class="col txt">
          <p v-if="!billet.jeuAfficher"> ... </p>
          <p v-else> {{ billet.jeuAfficher }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Type de mise :</label>
        </div>
        <div class="col txt">
          <p v-if="!billet.typeMiseAfficher"> ... </p>
          <p v-else> {{ billet.typeMiseAfficher }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Numéro de contrôle :</label>
        </div>
        <div class="col txt">
          <p v-if="!billet.numeroControle"> ... </p>
          <p v-else> {{ billet.numeroControle }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Date de l'avis au PAG :</label>
        </div>
        <div class="col-8 txt">
          <p v-if="!billet.payerLe"> ... </p>
          <p v-else> {{ $commun.formatDateHeure(billet.payerLe) }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Formule groupe :</label>
        </div>
        <div class="col txt">
          {{ $commun.formatBoolean(billet.formuleGroupe) }}
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Valeur du billet :</label>
        </div>
        <div class="col txt">
          <p v-if="!billet.valeur"> ... </p>
          <p v-else> {{ $commun.formatCurrency(billet.valeur) }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Montant du lot total :</label>
        </div>
        <div class="col txt">
          <p v-if="!billet.montantLot"> ... </p>
          <p v-else> {{ $commun.formatCurrency(billet.montantLot) }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Participation à l'Extra :</label>
        </div>
        <div class="col txt">
          {{ $commun.formatBoolean(billet.extra) }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Extra gagnant :</label>
        </div>
        <div class="col txt">
          {{ $commun.formatBoolean(billet.extraGagnant) }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Montant du lot de l'Extra :</label>
        </div>
        <div class="col txt">
          <p v-if="!billet.montantExtra"> ... </p>
          <p v-else> {{ $commun.formatCurrency(billet.montantExtra) }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl text-vertical-center">
          <label>Participation tirage/télévision :</label>
        </div>
        <div class="col txt">
          {{ $commun.formatBoolean(billet.participation) }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="container col-6 border">
        <div class="row">
          <div class="col lbl center">
            <u><h5>Provenance du billet</h5></u>
          </div>
        </div>
        <div class="row">
          <div class="col-6 lbl text-vertical-center">
            <label>Numéro détaillant :</label>
          </div>
          <div class="col txt">
            <p v-if="!billet.provenanceDetaillant"> ... </p>
            <p v-else> {{ billet.provenanceDetaillant.numeroFiche }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 lbl text-vertical-center">
            <label>Détaillant :</label>
          </div>
          <div class="col txt">
            <p v-if="!billet.provenanceDetaillant"> ... </p>
            <p v-else> {{ billet.provenanceDetaillant.nom }} </p>
          </div>
        </div>
        <div class="row">
          <div class="solid-line">
          </div>
        </div>
        <div class="row">
          <div class="col-6 lbl text-vertical-center">
            <label>Date et heure d'achat :</label>
          </div>
          <div class="col txt">
            <p v-if="!billet.acheterLe"> ... </p>
            <p v-else> {{ $commun.formatDateHeure(billet.acheterLe) }} </p>
          </div>
        </div>
      </div>
      <div class="container col-6 border">
        <div class="row">
          <div class="col lbl center">
            <u><h5>Vérification du billet</h5></u>
          </div>
        </div>
        <div class="row">
          <div class="col-6 lbl text-vertical-center">
            <label>Numéro détaillant :</label>
          </div>
          <div class="col txt">
            <p v-if="!billet.verificationDetaillant"> ... </p>
            <p v-else> {{ billet.verificationDetaillant.numeroFiche }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 lbl text-vertical-center">
            <label>Détaillant :</label>
          </div>
          <div class="col txt">
            <p v-if="!billet.verificationDetaillant"> ... </p>
            <p v-else> {{ billet.verificationDetaillant.nom }} </p>
          </div>
        </div>
        <div class="row">
          <div class="solid-line">
          </div>
        </div>
        <div class="row">
          <div class="col-6 lbl text-vertical-center">
            <label>Date et heure de vérification :</label>
          </div>
          <div class="col txt">
            <p v-if="!billet.verifierLe"> ... </p>
            <p v-else> {{ $commun.formatDateHeure(billet.verifierLe) }} </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="container col-6 border">
        <div class="row">
          <div class="col lbl center">
            <u><h5>Validation du billet</h5></u>
          </div>
        </div>
        <div class="row">
          <div class="col-6 lbl text-vertical-center">
            <label>Numéro détaillant :</label>
          </div>
          <div class="col txt">
            <p v-if="!billet.validationDetaillant"> ... </p>
            <p v-else> {{ billet.validationDetaillant.numeroFiche }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 lbl text-vertical-center">
            <label>Détaillant :</label>
          </div>
          <div class="col txt">
            <p v-if="!billet.validationDetaillant"> ... </p>
            <p v-else> {{ billet.validationDetaillant.nom }} </p>
          </div>
        </div>
        <div class="row">
          <div class="solid-line">
          </div>
        </div>
        <div class="row">
          <div class="col-6 lbl text-vertical-center">
            <label>Date et heure de validation :</label>
          </div>
          <div class="col txt">
            <p v-if="!billet.validerLe"> ... </p>
            <p v-else> {{ $commun.formatDateHeure(billet.validerLe) }} </p>
          </div>
        </div>
      </div>
      <div class="container col-6 border">
        <div class="row">
          <div class="col lbl center">
            <u><h5>Détaillant enquêté</h5></u>
          </div>
        </div>
        <div class="row">
          <div class="col-6 lbl text-vertical-center">
            <label>Numéro détaillant :</label>
          </div>
          <div class="col txt">
            <p v-if="!billet.fautifDetaillant"> ... </p>
            <p v-else> {{ billet.fautifDetaillant.numeroFiche }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 lbl text-vertical-center">
            <label>Détaillant :</label>
          </div>
          <div class="col txt">
            <p v-if="!billet.fautifDetaillant"> ... </p>
            <p v-else> {{ billet.fautifDetaillant.nom }} </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ButtonBar @fermer="fermer"/>
</template>

<script>
import ButtonBar from '../../../components/dossier/Consulter/ButtonBarBillet.vue'
import axios from 'axios';
import {mapGetters} from 'vuex';

export default {
  name: 'ConsulterBillet',
  components: {
    ButtonBar
  },
  mounted() {
    this.isDataLoading = true;

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Consulter un Billet");
    this.getBillet();
  },
  data() {
    return {
      isDataLoading: false,
      billet: {},
      classeSociete: null,
      provenanceDetaillant: {numeroFiche: null, nom: null},
      validationDetaillant: {numeroFiche: null, nom: null},
      verificationDetaillant: {numeroFiche: null, nom: null},
      fautifDetaillant: {numeroFiche: null, nom: null},
    };
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  methods: {
    getBillet() {
      this.$store.dispatch('billet/consulterBilletAction', {
        cle: this.$route.params.cle,
        site: this.$route.params.site
      }).then((res) => {
        this.assignerBillet(res);
        this.isDataLoading = false;
      })
    },
    assignerBillet(res) {
      this.billet = res.data.entite;
      if (this.billet.provenanceDetaillant == null) {
        this.billet.provenanceDetaillant = this.provenanceDetaillant;
      }
      if (this.billet.validationDetaillant == null) {
        this.billet.validationDetaillant = this.validationDetaillant;
      }
      if (this.billet.verificationDetaillant == null) {
        this.billet.verificationDetaillant = this.verificationDetaillant;
      }
      if (this.billet.fautifDetaillant == null) {
        this.billet.fautifDetaillant = this.fautifDetaillant;
      }
      this.classeSociete = res.data.entite.classeSociete;
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
}
</script>
